import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex align-center ga-3 mb-6" }
const _hoisted_2 = {
  class: "flex-grow-1",
  style: {"min-width":"0"}
}
const _hoisted_3 = { class: "text-caption text-medium-emphasis" }
const _hoisted_4 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_5 = { class: "text-caption text-medium-emphasis mt-3" }
const _hoisted_6 = { class: "d-flex align-center flex-wrap ga-2 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_EditorBlock = _resolveComponent("EditorBlock")!
  const _component_BrainPicker = _resolveComponent("BrainPicker")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_FunctionSelectionDialog = _resolveComponent("FunctionSelectionDialog")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_AgentShareDialog = _resolveComponent("AgentShareDialog")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_btn, {
        icon: "mdi-arrow-left",
        variant: "text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_text_field, {
          modelValue: _ctx.draft.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.draft.name) = $event)),
          variant: "plain",
          density: "compact",
          "hide-details": "",
          placeholder: "Assistant name",
          class: "text-h5 font-weight-bold assistant-name"
        }, null, 8, ["modelValue"]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.brainLabel ? `Runs on ${_ctx.brainLabel}` : 'No brain selected yet'), 1)
      ]),
      _createVNode(_component_v_tooltip, {
        disabled: !_ctx.saveDisabled,
        text: "Name, description, instructions and a brain are required.",
        location: "top"
      }, {
        activator: _withCtx(({ props }) => [
          _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
            _createVNode(_component_v_btn, {
              color: "primary",
              loading: _ctx.saving,
              disabled: _ctx.saveDisabled,
              onClick: _ctx.save
            }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode("Save")
              ])),
              _: 1,
              __: [15]
            }, 8, ["loading", "disabled", "onClick"])
          ], 16)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(_component_EditorBlock, {
      n: "1",
      title: "What it does",
      hint: "Describe what it should do, then the instructions it follows. With a name, description and brain set, the ⚡ writes the instructions from your description."
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_textarea, {
          modelValue: _ctx.draft.desc,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.draft.desc) = $event)),
          variant: "outlined",
          density: "compact",
          "hide-details": "",
          "auto-grow": "",
          rows: "2",
          class: "mb-4",
          placeholder: "What should this assistant do? Add a brain below, then the ⚡ writes its instructions from this."
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_textarea, {
          modelValue: _ctx.draft.instructions,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.draft.instructions) = $event)),
          loading: _ctx.autofilling,
          disabled: _ctx.autofilling,
          variant: "outlined",
          density: "compact",
          "hide-details": "",
          "auto-grow": "",
          rows: "5",
          placeholder: "How it should behave…"
        }, {
          "append-inner": _withCtx(() => [
            (_ctx.canAutofill)
              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 0,
                  text: "Autofill"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_icon, _mergeProps(props, {
                      color: "primary",
                      icon: "mdi-lightning-bolt-outline",
                      class: "autofill-icon",
                      onClick: _ctx.autofillInstructions
                    }), null, 16, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "loading", "disabled"])
      ]),
      _: 1
    }),
    _createVNode(_component_EditorBlock, {
      n: "2",
      title: "Its brain",
      hint: "Which model powers it. Keys live on the Providers tab."
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BrainPicker, {
          "model-value": _ctx.selectedModelId,
          models: _ctx.modelConfigsList,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedModelId = $event))
        }, null, 8, ["model-value", "models"])
      ]),
      _: 1
    }),
    _createVNode(_component_EditorBlock, {
      n: "3",
      title: "What it can do",
      hint: "Connect tools so it can take action."
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_select, {
          modelValue: _ctx.draft.tools,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.draft.tools) = $event)),
          items: _ctx.toolNames,
          variant: "outlined",
          density: "compact",
          "hide-details": "",
          multiple: "",
          chips: "",
          "closable-chips": "",
          placeholder: "Add tools…"
        }, null, 8, ["modelValue", "items"]),
        (_ctx.draft.tools.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_v_btn, {
                variant: "text",
                size: "small",
                class: "ml-n2",
                "prepend-icon": "mdi-tune-variant",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.functionsOpen = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Choose specific actions (" + _toDisplayString(_ctx.selectedFunctionsCount) + " selected) ", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_FunctionSelectionDialog, {
                show: _ctx.functionsOpen,
                "selected-tool-names": _ctx.draft.tools,
                "initial-selected-functions": _ctx.selectedFunctions,
                onSave: _ctx.onFunctionsSave,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.functionsOpen = $event))
              }, null, 8, ["show", "selected-tool-names", "initial-selected-functions", "onSave"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, " Memory (documents): " + _toDisplayString(_ctx.draft.memory ? 'on' : 'off') + " — manage in Advanced. ", 1)
      ]),
      _: 1
    }),
    _createVNode(_component_EditorBlock, {
      n: "4",
      title: "Voice",
      hint: "Give it a voice so it can speak its replies aloud."
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_select, {
          modelValue: _ctx.draft.voice,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.draft.voice) = $event)),
          items: _ctx.voiceNames,
          variant: "outlined",
          density: "compact",
          "hide-details": "",
          clearable: "",
          placeholder: "No voice"
        }, null, 8, ["modelValue", "items"])
      ]),
      _: 1
    }),
    _createVNode(_component_EditorBlock, {
      n: "5",
      title: "Publishing",
      hint: "Publish it so other people can use it."
    }, {
      default: _withCtx(() => [
        (!_ctx.isDraft)
          ? (_openBlock(), _createBlock(_component_v_switch, {
              key: 0,
              "model-value": _ctx.published,
              color: "primary",
              density: "compact",
              "hide-details": "",
              label: _ctx.published ? 'Published' : 'Not published',
              "onUpdate:modelValue": _ctx.togglePublish
            }, null, 8, ["model-value", "label", "onUpdate:modelValue"]))
          : (_openBlock(), _createBlock(_component_v_switch, {
              key: 1,
              modelValue: _ctx.publishOnSave,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.publishOnSave) = $event)),
              color: "primary",
              density: "compact",
              "hide-details": "",
              label: _ctx.publishOnSave ? 'Will publish when saved' : 'Publish for others'
            }, null, 8, ["modelValue", "label"])),
        (!_ctx.isDraft && _ctx.published)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "tonal",
                  "prepend-icon": "mdi-share-variant",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showShare = true))
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createTextVNode(" Share ")
                  ])),
                  _: 1,
                  __: [16]
                }),
                (_ctx.publicUrl)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      variant: "text",
                      "prepend-icon": "mdi-open-in-new",
                      href: _ctx.publicUrl,
                      target: "_blank",
                      rel: "noopener"
                    }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode(" Open public page ")
                      ])),
                      _: 1,
                      __: [17]
                    }, 8, ["href"]))
                  : _createCommentVNode("", true),
                (_ctx.publishedSlug)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      variant: "text",
                      "prepend-icon": "mdi-chat-outline",
                      onClick: _ctx.goToChat
                    }, {
                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                        _createTextVNode(" Message it ")
                      ])),
                      _: 1,
                      __: [18]
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.publicUrl)
                ? (_openBlock(), _createBlock(_component_v_text_field, {
                    key: 0,
                    "model-value": _ctx.publicUrl,
                    label: "Public link",
                    readonly: "",
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    class: "mt-3",
                    "append-inner-icon": "mdi-content-copy",
                    "onClick:appendInner": _ctx.copyPublicUrl
                  }, null, 8, ["model-value", "onClick:appendInner"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (!_ctx.isDraft)
          ? (_openBlock(), _createBlock(_component_AgentShareDialog, {
              key: 3,
              modelValue: _ctx.showShare,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showShare) = $event)),
              "owner-username": _ctx.username,
              slug: _ctx.publishedSlug,
              "agent-name": _ctx.agent.name
            }, null, 8, ["modelValue", "owner-username", "slug", "agent-name"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!_ctx.isDraft)
      ? (_openBlock(), _createBlock(_component_EditorBlock, {
          key: 0,
          title: "Delete",
          hint: "Removes this assistant for good — it disappears from Advanced too."
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              color: "error",
              variant: "tonal",
              "prepend-icon": "mdi-trash-can-outline",
              loading: _ctx.deleting,
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.confirmDelete = true))
            }, {
              default: _withCtx(() => _cache[19] || (_cache[19] = [
                _createTextVNode(" Delete this assistant ")
              ])),
              _: 1,
              __: [19]
            }, 8, ["loading"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmationDialog, {
      modelValue: _ctx.confirmDelete,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.confirmDelete) = $event)),
      title: "Delete assistant?",
      message: "This deletes the real agent — it disappears from Advanced too.",
      "item-name": _ctx.agent.name,
      "item-type": "assistant",
      onConfirm: _ctx.onDeleteConfirm,
      onCancel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.confirmDelete = false))
    }, null, 8, ["modelValue", "item-name", "onConfirm"])
  ]))
}